import React, { useRef, useState } from "react";
import { IonModal, IonContent } from "@ionic/react";
import { useSelector } from "react-redux";
import { actions } from "../../Redux/store";
import SleeperModalImg from "../../assets/imgs/sleeper_heading.png";
import { hapticsImpactLight } from "../../lib/utils";
import sleeperBackground from "../../assets/imgs/sleeper_background.png";
import { useMixpanel } from "../../Context/MixpanelContext/MixpanelProvider";

interface SleeperModal {
  isSleeperModal: boolean;
  toggleSleeperModal: () => void;
}

export default function SleeperModal() {
  const isSleeperModal = useSelector(
    (sate: any) => sate.modal.sleeperModal?.open,
  );
  const modal = useRef<HTMLIonModalElement>(null);
  const inputRef = useRef<HTMLInputElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);
  const Mixpanel = useMixpanel();
  const toggleSleeperModal = () => {
    actions.modal.closeSleeperModal(null);
  };

  const closeSleeperModal = () => {
    toggleSleeperModal();
  };

  function dismiss() {
    setSleeperUserName("");
    modal.current?.dismiss();
    closeSleeperModal();
  }

  const [sleeperUserName, setSleeperUserName] = useState("");

  // Handle Sync button click without losing focus
  const handleSyncClick = (e: React.MouseEvent) => {
    if (sleeperUserName.trim() === "") {
      return;
    }
    Mixpanel.trackEvent("league_sync_sleeper_details_entered", {
      name: "User entered Sleeper username for league sync",
    });
    hapticsImpactLight();
    dismiss();
    actions.modal.openLeagueSelectionModal({
      type: "SLEEPER",
      data: {
        provider: "SLEEPER",
        ownerUsename: sleeperUserName.trim(),
      },
    });
    console.log("Syncing with username:", sleeperUserName.trim());
  };

  // Focus input when modal is presented
  const handleModalPresent = () => {
    setTimeout(() => {
      inputRef.current?.focus();
    }, 150); // Small delay to ensure modal is fully rendered
  };

  // Remove focus when modal is dismissed
  const handleModalWillDismiss = () => {
    inputRef.current?.blur();
  };

  const handleContentClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    inputRef.current?.focus();
  };

  return (
    <IonModal
      onDidDismiss={dismiss}
      onIonModalDidPresent={handleModalPresent}
      onIonModalWillDismiss={handleModalWillDismiss}
      isOpen={isSleeperModal}
      backdropDismiss={true}
      ref={modal}
      className="sleeper-modal"
      initialBreakpoint={0.9}
      breakpoints={[0, 0.9]}
    >
      <IonContent scrollY={true} onClick={handleContentClick}>
        <div
          className="overflow-y-auto overscroll-none"
          style={{
            backgroundImage: `url(${sleeperBackground})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            height: "100%",
          }}
        >
          <img
            src={SleeperModalImg}
            alt="CapabilitiesModal Background"
            className="w-full pointer-events-none"
          />
          <div className="flex-col items-center justify-center pt-6 w-full px-4">
            <div>
              <p className="text-[24.76px] font-semibold text-white text-center pointer-events-none">
                Sync With Sleeper
              </p>
              <p className="text-[12.03px] font-normal text-white/50 text-center leading-[145%] mt-1 pointer-events-none">
                Enter your Sleeper username to link your league with RotoBot for
                personalized insights.
              </p>
            </div>

            <div className="mt-6">
              <input
                ref={inputRef}
                type="text"
                className={`bg-white/10 px-[14px] h-[49.14px] gap-[10px] w-full rounded-[34px] outline-none focus:outline-none text-white text-[12.89px] placeholder:text-white/70`}
                onChange={(event) => setSleeperUserName(event.target.value)}
                placeholder="Enter Username"
                value={sleeperUserName}
              />

              <div className="mt-10">
                <button
                  ref={buttonRef}
                  className="h-[48.12px] w-full bg-[#314E57] rounded-[34.36px] flex items-center justify-center"
                  onClick={handleSyncClick}
                >
                  <span className="text-white text-[12.03px] font-semibold">
                    Sync Now
                  </span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </IonContent>
    </IonModal>
  );
}
